import {create} from "zustand";

export const useModalStore = create((set) => ({
    // Модальное окно "Задать вопрос"
    askQuestionFlag: false,

    // Модальное окно "Написать отзыв"
    writeReviewFlag: false,
    // ID украшения для модального окна "Написать отзыв"
    writeReviewProductId: null,
    // Выбранная оценка для модального окна "Написать отзыв"
    writeReviewNewRating: 5,

    // Модальное окно "Поиск"
    searchModalFlag: false,

    // Модальное окно "Скидка на первый заказ"
    discountFirstOrderModalFlag: false,

    // Модальное окно "Тайный санта"
    secretSantaModalFlag: false,

    // Модальное окно "Поделиться товарами" в корзине
    shareBasketModalFlag: false,

    // Модальное окно "Поделиться товарами" в корзине
    whySuchPriceModalFlag: false,

    // Модальное окно "Весенний календарь подарков"
    giftCalendarModalFlag: false,

    // Модальное окно "Авторизация или Регистрация"
    authOrRegisterFlag: false,

    /**
     * Открыть модальное окно "Задать вопрос"
     */
    openModalAskQuestion: () => set({askQuestionFlag: true}),

    /**
     * Закрыть модальное окно "Задать вопрос"
     */
    closeModalAskQuestion: () => set({askQuestionFlag: false}),

    /**
     * Открыть модальное окно "Написать отзыв"
     */
    openModalWriteReview: (writeReviewProductId, writeReviewNewRating = 5) => set({
        writeReviewFlag: true,
        writeReviewProductId,
        writeReviewNewRating
    }),

    /**
     * Закрыть модальное окно "Написать отзыв"
     */
    closeModalWriteReview: () => set({
        writeReviewFlag: false,
        writeReviewProductId: null,
        writeReviewNewRating: 5
    }),

    /**
     * Открыть модальное окно "Поиск"
     */
    openSearchModal: () => set({searchModalFlag: true}),

    /**
     * Закрыть модальное окно "Поиск"
     */
    closeSearchModal: () => set({searchModalFlag: false}),

    /**
     * Открыть модальное окно "Скидка на первый заказ"
     */
    openDiscountFirstOrderModal: () => set({discountFirstOrderModalFlag: true}),

    /**
     * Закрыть модальное окно "Скидка на первый заказ"
     */
    closeDiscountFirstOrderModal: () => set({discountFirstOrderModalFlag: false}),

    /**
     * Открыть модальное окно "Тайный санта"
     */
    openSecretSantaModal: () => set({secretSantaModalFlag: true}),

    /**
     * Закрыть модальное окно "Тайный санта"
     */
    closeSecretSantaModal: () => set({secretSantaModalFlag: false}),

    /**
     * Открыть модальное окно "Поделиться товарами" в корзине
     */
    openShareProductsBasketModal: () => set({shareBasketModalFlag: true}),

    /**
     * Закрыть модальное окно "Поделиться товарами" в корзине
     */
    closeShareProductsBasketModal: () => set({shareBasketModalFlag: false}),

    /**
     * Открыть модальное окно "Почему такая цена?" - деталка
     */
    openWhySuchPriceModal: () => set({whySuchPriceModalFlag: true}),
    /**
     * Закрыть модальное окно "Почему такая цена?" - деталка
     */
    closeWhySuchPriceModal: () => set({whySuchPriceModalFlag: false}),

    /**
     * Открыть модальное окно "Весенний календарь подарков"
     */
    openGiftCalendarModal: () => set({giftCalendarModalFlag: true}),

    /**
     * Закрыть модальное окно "Весенний календарь подарков"
     */
    closeGiftCalendarModal: () => set({giftCalendarModalFlag: false}),

    /**
     * Открыть модальное окно "Авторизация или Регистрация"
     */
    openModalAuthOrRegister: () => set({authOrRegisterFlag: true}),

    /**
     * Закрыть модальное окно "Авторизация или Регистрация"
     */
    closeModalAuthOrRegister: () => set({authOrRegisterFlag: false}),
}));
